/* Tema HD Impressoras — comportamento das páginas (sem dependências) */
(function () {
  "use strict";

  var $ = function (sel, raiz) { return (raiz || document).querySelector(sel); };
  var $$ = function (sel, raiz) { return Array.prototype.slice.call((raiz || document).querySelectorAll(sel)); };

  /* ---------- Eventos de negócio no dataLayer (mesmos nomes do site de vendas) ---------- */
  function registrarEvento(evento, dados) {
    window.dataLayer = window.dataLayer || [];
    var item = { event: evento };
    for (var k in dados || {}) item[k] = dados[k];
    window.dataLayer.push(item);
  }

  /* Um único ouvinte cobre todos os botões de WhatsApp */
  document.addEventListener("click", function (e) {
    var link = e.target.closest && e.target.closest('a[href*="wa.me"], a[href*="whatsapp.com"]');
    if (!link) return;
    var texto = (link.getAttribute("aria-label") || link.textContent || "").replace(/\s+/g, " ").trim();
    registrarEvento("clique_whatsapp", { pagina: location.pathname, texto: texto.slice(0, 60) || null });
  });

  /* ---------- Menu lateral do celular ---------- */
  var menu = $("#menu-lateral");
  var fundo = $(".cat-menu-fundo");
  var botaoMenu = $("[data-abrir-menu]");
  /* trava a página atrás do menu; no Safari do iPhone overflow: hidden no body não basta,
     então o body fica fixo na posição atual e volta para ela ao fechar */
  var rolagemSalva = 0;
  function travarPagina(travar) {
    var b = document.body;
    if (travar) {
      rolagemSalva = window.scrollY;
      b.style.position = "fixed";
      b.style.top = -rolagemSalva + "px";
      b.style.left = "0";
      b.style.right = "0";
      b.style.overflow = "hidden";
    } else {
      b.style.position = b.style.top = b.style.left = b.style.right = b.style.overflow = "";
      window.scrollTo(0, rolagemSalva);
    }
  }
  function abrirMenu(abrir) {
    if (!menu) return;
    if (menu.hidden === !abrir) return;
    menu.hidden = !abrir;
    if (fundo) fundo.hidden = !abrir;
    if (botaoMenu) botaoMenu.setAttribute("aria-expanded", abrir ? "true" : "false");
    travarPagina(abrir);
    // preventScroll: devolver o foco ao botão do menu não pode levar a página de volta ao topo
    if (abrir) { var f = $("button", menu); if (f) f.focus({ preventScroll: true }); }
    else if (botaoMenu) botaoMenu.focus({ preventScroll: true });
  }
  if (botaoMenu) botaoMenu.addEventListener("click", function () { abrirMenu(true); });
  $$("[data-fechar-menu]").forEach(function (el) { el.addEventListener("click", function () { abrirMenu(false); }); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && menu && !menu.hidden) abrirMenu(false); });

  /* ---------- Ordenação da coleção: troca a URL ao escolher ---------- */
  $$("[data-auto-envio]").forEach(function (sel) {
    sel.addEventListener("change", function () { sel.form.submit(); });
  });

  /* ---------- Menu de ordenação: fecha ao clicar fora e com Esc ---------- */
  $$("[data-ordem]").forEach(function (menuOrdem) {
    document.addEventListener("click", function (e) {
      if (menuOrdem.open && !menuOrdem.contains(e.target)) menuOrdem.open = false;
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && menuOrdem.open) { menuOrdem.open = false; $("summary", menuOrdem).focus(); }
    });
  });

  /* ---------- Quantidade: botões − e + ---------- */
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-qtd]");
    if (!b) return;
    var input = $("input", b.parentNode);
    var min = Number(input.min || 0);
    input.value = Math.max(min, (Number(input.value) || 0) + Number(b.getAttribute("data-qtd")));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* Carrinho: mudar a quantidade atualiza sozinho (sem precisar do botão) */
  var formCarrinho = $("#form-carrinho");
  if (formCarrinho) {
    var espera;
    formCarrinho.addEventListener("change", function (e) {
      if (!e.target.matches("[data-auto-atualizar]")) return;
      clearTimeout(espera);
      espera = setTimeout(function () {
        var update = $('button[name="update"]', formCarrinho);
        if (formCarrinho.requestSubmit && update) formCarrinho.requestSubmit(update);
        else { var h = document.createElement("input"); h.type = "hidden"; h.name = "update"; h.value = "1"; formCarrinho.appendChild(h); formCarrinho.submit(); }
      }, 600);
    });
  }

  /* ---------- Galeria do produto ---------- */
  var galeria = $("[data-galeria]");
  if (galeria) {
    // setas (PC) e arrasto (celular) passam para a mídia vizinha, clicando na miniatura dela
    var passarMidia = function (passo) {
      var minis = $$("[data-galeria-mini]", galeria);
      if (minis.length < 2) return;
      var atual = minis.findIndex(function (m) { return m.classList.contains("prod-miniatura--ativa"); });
      minis[(Math.max(atual, 0) + passo + minis.length) % minis.length].click();
    };
    galeria.addEventListener("click", function (e) {
      var seta = e.target.closest("[data-galeria-passo]");
      if (seta) passarMidia(Number(seta.getAttribute("data-galeria-passo")));
    });
    var caixaGaleria = $(".prod-galeria", galeria);
    var toqueX = null, toqueY = 0;
    caixaGaleria.addEventListener("touchstart", function (e) {
      toqueX = e.touches[0].clientX; toqueY = e.touches[0].clientY;
    }, { passive: true });
    caixaGaleria.addEventListener("touchend", function (e) {
      if (toqueX === null) return;
      var dx = e.changedTouches[0].clientX - toqueX, dy = e.changedTouches[0].clientY - toqueY;
      toqueX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) passarMidia(dx < 0 ? 1 : -1);
    }, { passive: true });

    galeria.addEventListener("click", function (e) {
      var mini = e.target.closest("[data-galeria-mini]");
      if (!mini) return;
      var caixa = $(".prod-galeria", galeria);
      var principal = $("[data-galeria-principal]", galeria) || $(".prod-galeria img", galeria);
      var player = $(".prod-galeria-video", galeria);
      if (player) player.remove();
      var video = mini.getAttribute("data-video");
      if (video) {
        // vídeo da mídia do produto: o player entra no lugar da foto e já começa a tocar
        if (mini.getAttribute("data-video-tipo") === "arquivo") {
          player = document.createElement("video");
          player.src = video;
          player.controls = true;
          player.autoplay = true;
          player.playsInline = true;
        } else {
          player = document.createElement("iframe");
          player.src = video;
          player.title = "Vídeo do produto";
          player.allow = "autoplay; encrypted-media; picture-in-picture; fullscreen";
          player.allowFullscreen = true;
        }
        player.className = "prod-galeria-video";
        caixa.appendChild(player);
        if (principal) principal.hidden = true;
      } else if (principal) {
        principal.hidden = false;
        principal.src = mini.getAttribute("data-src");
        principal.srcset = mini.getAttribute("data-srcset");
      }
      $$("[data-galeria-mini]", galeria).forEach(function (m) {
        var ativa = m === mini;
        m.classList.toggle("prod-miniatura--ativa", ativa);
        m.setAttribute("aria-pressed", ativa ? "true" : "false");
      });
    });
  }

  /* ---------- Variantes: escolher as opções atualiza o id, o preço e o botão ---------- */
  var dadosProduto = $("[data-produto-json]");
  var formProduto = $("[data-form-produto]");
  if (dadosProduto && formProduto) {
    var produto = JSON.parse(dadosProduto.textContent);
    var selects = $$("[data-opcao]", formProduto);
    var formato = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });
    var dinheiro = function (centavos) { return formato.format(centavos / 100); };

    function atualizarVariante() {
      var escolhidas = selects.map(function (s) { return s.value; });
      var v = produto.variants.find(function (x) {
        return x.options.every(function (o, i) { return o === escolhidas[i]; });
      });
      var botao = $("[data-botao-comprar]", formProduto);
      if (!v) {
        if (botao) { botao.disabled = true; botao.textContent = "Indisponível"; }
        return;
      }
      $("[data-variante-id]", formProduto).value = v.id;
      if (botao) { botao.disabled = !v.available; botao.textContent = v.available ? "Comprar agora" : "Indisponível"; }
      var precos = $("[data-precos]");
      if (precos && v.price > 0) {
        var html = "";
        if (v.compare_at_price > v.price) {
          var pct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
          html += '<div class="prod-de"><span class="selo-off">' + pct + "% OFF</span><s>" + dinheiro(v.compare_at_price) + "</s></div>";
        }
        html += '<p class="prod-preco">' + dinheiro(v.price) + "</p>";
        precos.innerHTML = html;
      }
      if (v.featured_image) {
        var principal = $("[data-galeria-principal]");
        if (principal) { principal.removeAttribute("srcset"); principal.src = v.featured_image.src; }
      }
      var url = new URL(location.href);
      url.searchParams.set("variant", v.id);
      history.replaceState(null, "", url.toString());
    }
    selects.forEach(function (s) { s.addEventListener("change", atualizarVariante); });
  }

  /* ---------- Vídeo do YouTube: o player só carrega no clique ---------- */
  document.addEventListener("click", function (e) {
    var capa = e.target.closest && e.target.closest(".video-capa");
    if (!capa) return;
    var caixa = capa.closest("[data-youtube]");
    var iframe = document.createElement("iframe");
    iframe.src = "https://www.youtube-nocookie.com/embed/" + caixa.getAttribute("data-youtube") + "?autoplay=1&rel=0";
    iframe.title = caixa.getAttribute("data-titulo") || "Vídeo";
    iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
    iframe.referrerPolicy = "strict-origin-when-cross-origin";
    iframe.allowFullscreen = true;
    caixa.innerHTML = "";
    caixa.appendChild(iframe);
  });

  /* ---------- Reels: um toca por vez; abrir outro devolve a capa ao anterior ---------- */
  var reelTocando = null;
  document.addEventListener("click", function (e) {
    var reel = e.target.closest && e.target.closest("button.reel[data-reel]");
    if (!reel || !reel.getAttribute("data-reel")) return;
    if (reelTocando) reelTocando.restaurar();
    var capaHtml = reel.innerHTML;
    var video = document.createElement("video");
    video.src = reel.getAttribute("data-reel");
    var img = $("img", reel);
    if (img) video.poster = img.src;
    video.title = reel.getAttribute("data-titulo") || "";
    video.autoplay = true;
    video.controls = true;
    video.playsInline = true;
    video.setAttribute("controlslist", "nodownload noplaybackrate");
    video.disablePictureInPicture = true;
    reel.classList.add("reel--tocando");
    reel.innerHTML = "";
    reel.appendChild(video);
    reelTocando = {
      restaurar: function () {
        reel.classList.remove("reel--tocando");
        reel.innerHTML = capaHtml;
        reelTocando = null;
      }
    };
  });

  /* ---------- Altura do cabeçalho para o banner em vídeo ocupar o resto da tela ---------- */
  var cabecalho = $(".cat-header");
  if (cabecalho) {
    var medirCabecalho = function () {
      document.documentElement.style.setProperty("--altura-cabecalho", cabecalho.offsetHeight + "px");
    };
    medirCabecalho();
    window.addEventListener("resize", medirCabecalho);
    if (window.ResizeObserver) new ResizeObserver(medirCabecalho).observe(cabecalho);
  }

  /* ---------- Banner em vídeo: celulares bloqueiam o autoplay com facilidade ---------- */
  $$("[data-video-fundo]").forEach(function (v) {
    v.muted = true;
    v.defaultMuted = true;
    var tocar = function () {
      if (v.paused && document.visibilityState === "visible") { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    };
    tocar();
    v.addEventListener("loadeddata", tocar);
    v.addEventListener("canplay", tocar);
    document.addEventListener("visibilitychange", tocar);
    ["touchstart", "click", "scroll"].forEach(function (g) { window.addEventListener(g, tocar, { passive: true, once: true }); });
  });

  /* ---------- Slide das avaliações ---------- */
  $$("[data-slide]").forEach(function (slide) {
    var trilho = $("[data-slide-trilho]", slide);
    var ant = $("[data-slide-ant]", slide);
    var prox = $("[data-slide-prox]", slide);
    var passo = function () { var c = trilho.firstElementChild; return c ? c.getBoundingClientRect().width + 30 : 300; };
    var atualizar = function () {
      ant.disabled = trilho.scrollLeft <= 2;
      prox.disabled = trilho.scrollLeft + trilho.clientWidth >= trilho.scrollWidth - 2;
    };
    ant.addEventListener("click", function () { trilho.scrollBy({ left: -passo(), behavior: "smooth" }); });
    prox.addEventListener("click", function () { trilho.scrollBy({ left: passo(), behavior: "smooth" }); });
    trilho.addEventListener("scroll", atualizar, { passive: true });
    window.addEventListener("resize", atualizar);
    atualizar();
  });

  /* ---------- Busca com sugestões enquanto digita (Predictive Search da Shopify) ---------- */
  $$("[data-busca-preditiva]").forEach(function (form) {
    var campo = $('input[name="q"]', form);
    var caixa = $(".busca-sugestoes", form);
    if (!campo || !caixa) return;
    var url = form.getAttribute("data-url") || "/search/suggest";
    var formato = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });
    var espera, pedido, ativo = -1;
    var esc = function (s) { return String(s || "").replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };

    function fechar() {
      caixa.hidden = true;
      campo.setAttribute("aria-expanded", "false");
      ativo = -1;
    }
    function opcoes() { return $$(".busca-item", caixa); }
    function marcar(i) {
      var lista = opcoes();
      if (!lista.length) return;
      ativo = (i + lista.length) % lista.length;
      lista.forEach(function (el, k) { el.classList.toggle("busca-item--ativo", k === ativo); el.setAttribute("aria-selected", k === ativo ? "true" : "false"); });
    }

    function mostrar(produtos, termo) {
      var html = "";
      if (!produtos.length) {
        html = '<p class="busca-vazio">Nenhum produto encontrado para “' + esc(termo) + '”.</p>';
      } else {
        produtos.forEach(function (p) {
          var preco = parseFloat(p.price || 0);
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          if (img) img += (img.indexOf("?") > -1 ? "&" : "?") + "width=120";
          html += '<a class="busca-item" role="option" aria-selected="false" href="' + esc(p.url) + '">' +
            '<span class="busca-foto">' + (img ? '<img src="' + esc(img) + '" alt="" width="56" height="56" loading="lazy">' : "") + "</span>" +
            '<span class="busca-texto"><span class="busca-nome">' + esc(p.title) + "</span>" +
            '<span class="busca-preco">' + (preco > 0 ? formato.format(preco) : "Valor a negociar") + "</span></span></a>";
        });
      }
      html += '<a class="busca-todos" href="' + esc(form.action) + "?type=product&q=" + encodeURIComponent(termo) + '">Ver todos os resultados para “' + esc(termo) + '” →</a>';
      caixa.innerHTML = html;
      caixa.hidden = false;
      campo.setAttribute("aria-expanded", "true");
      ativo = -1;
    }

    function buscar() {
      var termo = campo.value.trim();
      if (termo.length < 2) { fechar(); return; }
      if (pedido) pedido.abort();
      pedido = window.AbortController ? new AbortController() : null;
      var q = url + ".json?q=" + encodeURIComponent(termo) +
        "&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last" +
        "&resources[options][fields]=title,product_type,variants.sku,vendor,tag";
      fetch(q, pedido ? { signal: pedido.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (dados) {
          var lista = ((dados.resources || {}).results || {}).products || [];
          // produtos de locação não aparecem no site de vendas
          lista = lista.filter(function (p) { return !/locacao/.test(p.handle || "") && !/Locação/.test(p.title || ""); }).slice(0, 6);
          if (campo.value.trim() === termo) mostrar(lista, termo);
        })
        .catch(function () {});
    }

    campo.addEventListener("input", function () { clearTimeout(espera); espera = setTimeout(buscar, 180); });
    campo.addEventListener("focus", function () { if (caixa.innerHTML && campo.value.trim().length >= 2) { caixa.hidden = false; campo.setAttribute("aria-expanded", "true"); } });
    campo.addEventListener("keydown", function (e) {
      if (caixa.hidden) return;
      if (e.key === "ArrowDown") { e.preventDefault(); marcar(ativo + 1); }
      else if (e.key === "ArrowUp") { e.preventDefault(); marcar(ativo - 1); }
      else if (e.key === "Enter" && ativo > -1) { e.preventDefault(); opcoes()[ativo].click(); }
      else if (e.key === "Escape") { fechar(); }
    });
    document.addEventListener("click", function (e) { if (!form.contains(e.target)) fechar(); });
  });

  /* ---------- Produtos semelhantes (API de recomendações) ---------- */
  var recomendacoes = $("[data-recomendacoes]");
  if (recomendacoes && !recomendacoes.children.length) {
    fetch(recomendacoes.getAttribute("data-url"))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement("div");
        tmp.innerHTML = html;
        var novo = $("[data-recomendacoes]", tmp);
        if (novo && novo.innerHTML.trim()) recomendacoes.innerHTML = novo.innerHTML;
      })
      .catch(function () {});
  }
})();
